import { cx } from '@/components/ui';
import './campaignOffer.css';

/*
 * Flat "hot offer" icons: solid fills in the --k-offer-* colours (campaignOffer.css), a darker
 * shade for depth, no gradients. They carry the colour on soft dark surfaces. Decorative: the
 * words always sit next to them.
 */

const TICKET =
  'M4 6h16a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8a2 2 0 0 1 2-2Z';

/** Tilted red ticket: notched ends, yellow frame, dotted tear line. */
export function OfferTicketIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cx('offer-icon offer-ticket-icon', className)} aria-hidden focusable="false">
      <g transform="rotate(-14 12 12)">
        <path d={TICKET} className="offer-ticket-icon__shade" transform="translate(0.6 1.1)" />
        <path d={TICKET} className="offer-ticket-icon__body" />
        <rect x="4.6" y="8.6" width="9" height="6.8" rx="0.9" className="offer-ticket-icon__frame" />
        <path d="M16.6 8.2v7.6" className="offer-ticket-icon__tear" />
      </g>
    </svg>
  );
}

/** Flat two-tone flame: red with a yellow core; flickers from its base. */
export function OfferFlame({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cx('offer-icon offer-flame', className)} aria-hidden focusable="false">
      <path
        className="offer-flame__outer"
        d="M12.4 1.6c.6 3.2-.4 5.1-1.9 7 1.7.1 3-1 3.6-2.5 1.7 1.9 4.6 4.8 4.6 8.7 0 .9-.1 1.7-.4 2.4 1.3-1 2-2.7 2-4.2.8 1.4 1.4 3 1.4 4.9 0 4.6-4.1 8.1-9.7 8.1S2.3 22.5 2.3 17.8c0-3.4 1.8-5.9 3.6-7.8.1 2 1 3.5 2.2 4.5-1-2.6-1.2-6.6 4.3-12.9Z"
      />
      <path
        className="offer-flame__core"
        d="M12 12.6c-2.2 2-3.3 3.8-3.3 5.6 0 1.9 1.4 3.3 3.3 3.3s3.3-1.4 3.3-3.3c0-1.3-.6-2.5-1.6-3.6-.1 1-.6 1.8-1.4 2.2.2-1.4 0-2.8-.3-4.2Z"
      />
    </svg>
  );
}

/** Stopwatch for time-limited offers; the hand ticks round (campaignOffer.css). */
export function OfferStopwatch({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cx('offer-icon offer-stopwatch', className)}
      aria-hidden
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    >
      <circle cx="12" cy="13.5" r="8" />
      <path d="M9.5 2.5h5M12 2.5v3M19.2 6.3l1.4-1.4" />
      <path className="offer-stopwatch__hand" d="M12 13.5V9" />
    </svg>
  );
}

/** Three yellow "pop" strokes, as on a sale sticker. */
export function OfferPopLines({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cx('offer-icon offer-pop-lines', className)}
      aria-hidden
      focusable="false"
      fill="none"
      strokeWidth="2.6"
      strokeLinecap="round"
    >
      <path d="M4 16.5l5-1.5M6 8.5l4.2 3M13.5 3.5l.3 5" />
    </svg>
  );
}
